<template >
    <div  style="height: 466px">
<!--        -->
        <el-form  :rules="rules" ref="lineForm" :model="editData" label-width="110px" size="mini" v-if="show">

            <el-form-item prop="name" class="lable-width" label="菜品名称" :rules="{required: true, message: '请输入菜品名称', trigger: 'blur'}">
                <el-input class="input-width" placeholder="请输入菜品名称" clearable v-model="editData.name" ></el-input>
            </el-form-item>
            <el-form-item prop="foodType" class="lable-width" label="菜品类型" :rules="{required: true, message: '请选择菜品类型', trigger: 'blur'}">
                <el-select clearable class="input-width"
                           @change="cpchange"
                           v-model="editData.foodType"
                           filterable placeholder="请选择菜品类型"
                           >
                    <el-option
                            v-for="item in cpTypedata"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item prop="price" class="lable-width" label="价格" >
                <el-input class="input-width" placeholder="请输入菜品价格" clearable v-model="editData.price" ></el-input>
            </el-form-item>
            <el-form-item prop="filePath" class="lable-width" label="图片">

                <div class="img-box">
                    <div class="uploadPhone flex fl-wr" id="uploadPhoto">
                        <ul v-if="imgList.length>0" class="flex">
                            <li v-for="(oneimg,index) in imgList" :key="index"
                                class="li-img mrr2" >
<!--                                <img :src="'http://'+oneimg.vc_path">-->
                                <div class="elimg">
                                <el-image class="img" :src="smcurl+oneimg.vc_path" :preview-src-list="[smcurl+oneimg.vc_path]"  :z-index="3000" >
                                    <div  slot="error" class="image-slot" style="text-align: center;line-height: 60px">
                                        <div>无</div>
                                    </div>
                                </el-image>
                                <i class="el-icon-delete" @click="removeli(oneimg,index)" ></i>
                                </div>
                            </li>
                        </ul>
                        <div class="upload-box flex1" v-model="editData.filePath" v-if="imgList.length==0">
                            <input type="file" name="files" :value="inputval" id="uploadfile1"
                                   class="upload-input uploadfile1" @change="upload" :disabled="hide">
                            <img  src="@/assets/custom_pic.png">
                        </div>
                    </div>
                </div>
            </el-form-item>
            <el-form-item prop="createTime" class="lable-width" label="发布时间">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.createTime" ></el-input>
                </div>
            </el-form-item>
            <el-form-item prop="vc_lruname" class="lable-width" label="录入人姓名">
                <div style="margin-left: 0px;position: relative">
                    <el-input  class="input-width" label="123" disabled  clearable v-model="editData.vc_lruname"></el-input>
                </div>
            </el-form-item>
            <el-form-item  label="是否启用">
                <div style="margin-left: 34px">
                    <el-radio v-model="editData.state" :label="1">启用</el-radio>
                    <el-radio v-model="editData.state" :label="0">不启用</el-radio>
                </div>
            </el-form-item>
            <el-form-item class="lable-width" style="margin-left: 0">
                <el-button style="margin-left: 0" type="primary" @click="onSubmit" :disabled="isDisable">{{$t('button_save')}}</el-button>
                <el-button type="primary" @click="close">取消</el-button>
            </el-form-item>

        </el-form>
    </div>
</template>

<script>
    import * as API from "../api";
    import {mapActions} from "vuex";
    import {smfile_root,erpplatserver} from '@/utils/baseUrl';

    export default {
        name: 'reviseTemplate',
        props:{
            title:{
              type:String
            },
            editData1:{
                type:Object
            }
        },
        data(){
            return{
                smcurl:'',
                dialogImageUrl: '',
                dialogVisible: false,
                typeList:[{
                    id:1,
                    v:'小碗菜'
                },{
                    id:2,
                    v:'熟食'
                }],
                cpTypedata:{},
                isDisable:false,
                editData:this.editData1,
                // editData:{name:"包子",foodType:0,price:2,filePath:"",createTime:'',vc_lruname:'',state:0},
                value:'',
                validateCode:'',
                validateKeynames:'',
                mainTable:'',
                imgList:[],
                type:'',
                i_lruid:'',
                deleteLi: "",
                deleteLidex:'',
                hide:false,
                show:false,
                fileid1:'',
                inputval:'',
                rules: {
                    price: [
                        {required: true, message: '请输入菜品价格', trigger: 'blur'},
                        // {pattern: /^-?\d+(\.\d+)?$/, message: "请输入合法面积", trigger: "blur" },
                        // {pattern: /^[0-9]*$/, message: "请输入数字", trigger: "blur" },
                        {pattern: /^[0-9]+\.{0,1}[0-9]{0,15}$/, message: "请输入大于0的数字", trigger: "blur" },
                        {pattern: /^\d+(\.\d{1,5})?$/, message: "请保留五位小数", trigger: "blur" }
                    ]
                }
            }
        },
        watch:{

        },
        mounted(){
            this.smcurl=smfile_root
            // console.log(this.imgList)
            // console.log(this)
            this.getDataDict()
            if(this.title=='编辑菜品'){
                this.getDetail()
            }else {
                this.show=true
            }
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            close(){
                this.$emit('close')
            },
            cpchange(val){
                // await  this.getDataDict()
                //  setTimeout(() => {
                this.cpTypedata.id=val
                // }, 1)
            },
            //删除li
            removeli(oneimg, index) {
                this.deleteLi = oneimg.i_fileid;
                this.deleteLidex = index;
                this.deletefile();
            },
            //li删除
            async deletefile() {
                // this.imgList.splice(this.deleteLidex, 1);
                this.imgList=[]
                this.inputval=''
                this.hide=false
                // console.log(this.imgList)
                /*let param = {
                    i_id: this.deleteLi,
                };
                let res = await API.deleteFileInfo(param);
                if (res.code == 1) {
                    this.$message.success(res.message);
                    this.imgList.splice(this.deleteLidex, 1);
                    //console.log(this.imgList, "newlist");
                    this.newarr = this.imgList;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }*/
            },
            onSubmit(){
                    // this.$emit('editData', this.editData)
                this.save()
            },
            //菜品类型下拉
            async getDataDict(val) {
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params={
                    type: 1,
                }
                let res = await API.getDataDict(params);
                if (res.code == 1) {
                    this.cpTypedata = res.data
                    // console.log(res.data)
                    // this.foodType=this.cpTypedata.id
                    // console.log(this.cpTypedata)
                    // let arr=[]
                    // this.kqdata.map(item=>{
                    //     arr.push(item.storekqId)
                    // })
                    // arr.map((value,i)=>{
                    // for (var i = 0; i < arr.length; i++) {
                    //     if(arr[i]==this.pid){
                    //         return
                    //     }else {
                    //         this.pid=''
                    //     }
                    // }
                    // let arr =  res.data;
                    // this.pid=arr[1].storepid
                    // this.getList()
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            //菜品详情
            async getDetail(val) {
                this.isDisable=true
                this.hide=true
                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    validateCode:this.editData.validateCode ,
                    validateKeynames:this.editData.validateKeynames,
                    mainTable:this.editData.mainTable ,
                    type:this.editData.type
                }
                let res = await API.getDetail(params);
                if (res.code == 1) {
                    this.isDisable=false
                    this.editData=res.data
                    // console.log(res.data)
                    let img ={}
                    img.i_fileid=res.data.fileId
                    img.vc_path=res.data.filePath
                    // console.log(img.vc_path)
                    if(!!img.vc_path){
                        this.imgList.push(img)
                        this.hide=true
                        // console.log(this.imgList)
                    }else{
                        this.hide=false
                    }
                    //console.log(this.imgList)
                    this.i_lruid=res.data.i_lruid
                    this.show=true
                } else if (res.code == -2) {
                    this.isDisable=false

                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.isDisable=false

                    this.$message.error(res.message);
                }
            },
            //菜品保存
            async save(val) {
                // rules
                // this.foodType=this.cpTypedata.id
                if(this.editData.name==''){
                    this.$message({
                        message: '请输入菜品名称',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.foodType==''){
                    this.$message({
                        message: '请选择菜品类型',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.price ==''){
                    this.$message({
                        message: '请输入菜品价格',
                        type: 'error'
                    });
                    return
                }
                if(this.editData.price<0){
                    this.$message({
                        message: '请输入大于0的价格',
                        type: 'error'
                    });
                    return
                }
                if(isNaN(this.editData.price)){
                    this.$message({
                        message: '请输入数字',
                        type: 'error'
                    });
                    return
                }


                let result = await this.getCurrentMenuId({path: this.$route.path});
                if (result.i_id !== "") {
                    this.mid = result.i_id
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let params = {
                    id:this.editData.id,
                    name:this.editData.name,
                    createTime:this.editData.createTime,
                    price:this.editData.price,
                    // foodType:this.editData.foodType,
                    foodType:this.cpTypedata.id,
                    state:this.editData.state,
                    i_lruid:this.editData.i_lruid,
                    creator:this.i_lruid,
                    validateCode:this.editData.validateCode,
                    validateKeynames:this.editData.validateKeynames,
                    mainTable:this.editData.mainTable,
                    type:this.editData.type,
                    filePath:this.imgList.length>0?this.imgList[0].vc_path:''
                    // fileId:this.imgList.length>0?this.imgList[0].i_fileid:this.fileid1
                }

                this.isDisable = true
                let res = await API.save(params);
                if (res.code == 1) {
                    this.isDisable = false
                    this.$emit("close")
                    this.$emit('getList')
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.isDisable = false
                    this.$message.error(res.message);
                }
            },
            //上传附件
            async upload(value) {
                this.hide=true
                var msg= this.$message({
                    message: '正在上传,请稍候',
                    type: 'warning'
                });
                // console.log("value",value)
                let that = this;
                // console.log("that",that)
                let i = 0;
                let $files = value.target.files[0];
                //console.log($files)

                let fileName = $files.name;
                // console.log("1",fileName)
                let type = $files.type;
                var list = {
                    "image/jpeg": true,
                    "image/png": true,
                    "image/jpg": true,
                    "image/bmp": true,
                    "application/pdf": true
                };
                let result = list[type];
                // if(($files && result==false) || ($files &&result==undefined)){
                //     that.$message.error('请上传格式正确的文件');
                //     return;
                // };
                if ($files) {
                    that.fileName = $files.name;
                    that.fileType = $files.type;
                    that.fileUrl = window.URL.createObjectURL(value.target.files[0]);
                } else {
                    that.fileName = "";
                    that.fileType = "";
                    that.fileUrl = "";
                }
                if (that.fileName) {
                    var fileId = 'uploadfile' + that.idNum;
                    var param = {
                        "file": fileId,
                        "fileName": that.fileName,
                        "IDtype": "",
                        "type": 1,
                        "style": "foodInfo",
                        "files": $files,
                        //"token":sessionStorage.getItem("token"),
                        //"app": "dsmanage",
                        "vc_app": "foodInfo",
                        "i_appid":0,
                        "version": "1.0",
                        "i_uid": sessionStorage.getItem("userid"),
                        "vc_lruname": this.editData.vc_lruname,
                        "i_lruid": this.editData.i_lruid,
                        "i_mid": 0
                    };
                    /*let abc = {
                        i_mid: this.mid,
                        style:"deliver",
                        vc_app:"deliver",
                        i_appid:this.commitId,
                        vc_lruname:this.form.vc_lruname,
                        i_lruid:this.form.i_lruid,
                    };*/
                    let FD = new FormData();
                    for (let key in param) {
                        FD.append(key, param[key])
                    }
                    // let res = await  fetch(upload,{
                    //     method:"post",
                    //     body:FD
                    // }).then(res=>res.text());

                    let res = await API.upload(param);
                    if (res.code == 1) {
                        msg.close()
                        this.$message({
                            message: '上传成功',
                            type: 'success'
                        });
                        this.hide=true;
                        //res =JSON.parse(res);
                        let data = res.data[0];
                        var imgPath = {};

                        this.fileid1 = data.i_id;
                        imgPath.i_fileid = data.i_id;
                        //imgPath.vc_name = data.filename;
                        imgPath.vc_path =data.savePath;
                        //imgPath.base64 = data.base64String;
                        //imgPath.filePath = data.i_id;
                        //imgPath.fileSort = that.didNum;
                        //imgPath.fileType = 1;
                        //imgPath.filenewname = data.filenewname;
                        // console.log(imgPath)
                        that.imgList.push(imgPath);
                        // console.log(that.imgList)
                        // that.imgList.push(imgPath);
                        that.didNum++;
                        that.idNum = that.didNum;
                        that.imgLength = that.imgList.length - 1;
                        that.editData.imgList = that.imgList;
                        // console.log(that.imgList,"that.imgList11111111111");
                        //that.srcData=that.imgList;
                        //that.Data=[...that.srcData];
                        //console.log(data, that.imgList, that.formData.imgList, "xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx")
                        //this.removeli();
                        //console.log(that.imgList, "newlist")
                    } else if (res.code == -2) {
                        msg.close()
                        this.$message({
                            message: '上传失败，请重新上传',
                            type: 'error'
                        });
                        this.imgList=[]
                        this.inputval=''
                        this.hide=false
                        this.$router.push('/login');
                        this.$message.error(res.message);
                    } else {
                        msg.close()
                        this.$message({
                            message: '上传失败，请重新上传',
                            type: 'error'
                        });
                        this.imgList=[]
                        this.inputval=''
                        this.hide=false
                        that.$message.error(res.message);
                    }
                }
            },
        }
    }
</script>
<style lang="scss" scoped>
    /deep/{
        .lable-width .el-form-item__content{
            margin-left: 0 !important;
        }
        .el-textarea__inner{
            height: 100px !important;
            color: #000000 !important;
            /*font-weight: 600 !important;*/
            font-size: inherit !important;
        }
        .el-form-item__error{
            left: 50% !important;
        }
    }
    .upload-box img{
        width: 80px !important;
        height: 80px !important;
    }
    .lable-width{
        text-align: center;
    }
    .slable-width{

    }
    .dialog-footer{
        display: flex;
        justify-content: center;
        align-items: center;
        /*text-align: center;*/
        margin-top: 12px;
    }
    .input-width{
        /*text-align: center;*/
        width: 18.571rem;
    }
    /*11111111111*/
    .mrr2{
        margin-right: 2px;
    }
    .img-box{
        /*border: 1px solid red;*/
        .uploadPhone{
            width: 70px;
            height: 80px;
            position: relative;
            width: 100px;
            padding-left: 50px;
            /*border: 1px solid cornflowerblue;*/
        }
        .uploadPhone .img{
            width: 80px;
            height: 80px;
            margin-right: 5px;
        }
        .elimg{
            width:105px
        }
        .el-icon-delete{
            padding-right: 5px;
        }


        .upload-box{
            /*background: red;*/
            width: 100%;
            height: 100%;
        }
        .upload-input{
            position: absolute;
            opacity: 0;
            width: 80px;
            height: 80px;
        }
    }
    .flex{
        display: flex;
    }
    .flex1{
        display: flex;
    }
    /*1111111111*/
    .sinput-width{
        width: 150px;
        margin-left: 28px;
    }
    /deep/.json .el-textarea__inner{
        height: 180px !important;
    }
    /deep/.describe .el-textarea__inner{
        height: 80px !important;

    }
</style>